import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';

import './assets/css/index.css'

// 导入 data-v 组件库，并注册为全局组件
import dataV from '@jiaminghi/data-view'
// import vueConfig from 'vue.config';
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
    key: '6d864a884c84088176fa04311f826ce0',
    plugin: ['AMap.Geolocation'],
    securityJsCode: 'd16fd5a4eb60fc4c069c11e5d5f3567c'
});
Vue.use(dataV)
    // axios.defaults.baseURL = 'http://127.0.0.1:3000/api/';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
